var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { PureComponent, createElement } from 'react';
import classNames from 'classnames';
import { assign, isEqual } from 'lodash';
import { ComponentsManager } from '@comall-backend-builder/core'; // import './index.scss';

import { extendsParentProps } from '../component-props';
import { services } from '@comall-backend-builder/core';

var FlexLayout = function (_super) {
  __extends(FlexLayout, _super);

  function FlexLayout(props) {
    var _this = _super.call(this, props) || this;

    _this.styleMap = {};
    return _this;
  }

  FlexLayout.prototype.render = function () {
    var _a, _b, _c;

    var _d = this.props,
        direction = _d.direction,
        align = _d.align,
        justify = _d.justify,
        className = _d.className,
        style = _d.style;
    className = classNames('layout', 'flex-layout', (_a = {}, _a["direction-" + direction] = !!direction, _a), (_b = {}, _b["align-" + align] = !!align, _b), (_c = {}, _c["justify-" + justify] = !!justify, _c), className);
    return React.createElement("div", {
      className: className,
      style: style
    }, this.renderItems());
  };
  /**
   * 渲染 flex item
   */


  FlexLayout.prototype.renderItems = function () {
    var _this = this;

    return this.props.items.map(function (itemDesc, index) {
      if (itemDesc.privilege) {
        var _a = itemDesc.privilege,
            path = _a.path,
            level = _a.level;

        if (!services.privilege.check(path, level)) {
          return undefined;
        }
      }

      var ItemComponent = ComponentsManager.get(itemDesc.component);

      var props = _this.getItemProps(itemDesc, index);

      var children = _this.props.children;
      return createElement(ItemComponent, props, children);
    });
  };
  /**
   * 生成 flex item 的 props 对象
   * @param {object} itemDesc - item 的配置对象
   * @param {any} key - item 的 key 值
   * @return {object} - 该 item 的 props
   */


  FlexLayout.prototype.getItemProps = function (itemDesc, key) {
    var component = itemDesc.component,
        otherProps = __rest(itemDesc, ["component"]);

    var props = extendsParentProps(__assign(__assign({}, otherProps), {
      key: key
    }), this.props);
    props.className = classNames('flex-layout-item', props.className); // 处理 flex item 的样式

    if (props.flex) {
      var mapKey = JSON.stringify(itemDesc);
      var cachedStyle = this.styleMap[mapKey];
      var style = assign({
        flex: props.flex,
        msFlex: props.flex
      }, props.style);

      if (!isEqual(style, cachedStyle)) {
        cachedStyle = style;
        this.styleMap[mapKey] = cachedStyle;
      }

      props.style = cachedStyle;
      delete props.flex;
    }

    return props;
  };

  return FlexLayout;
}(PureComponent);

export { FlexLayout };